import PropTypes from 'prop-types';


const offer = PropTypes.shape({
  companyLogo: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  isFavourite: PropTypes.bool,
  isOneClickApply: PropTypes.bool.isRequired,
  isRemoteRecruitment: PropTypes.bool.isRequired,
  isSuperOffer: PropTypes.bool.isRequired,
  jobTitle: PropTypes.string.isRequired,
  offerId: PropTypes.number.isRequired,
  offerURLName: PropTypes.string.isRequired,
  regionName: PropTypes.string.isRequired,
  workplace: PropTypes.string.isRequired
});

export default offer;
